import React, { useEffect, useState } from 'react';
import { projectsData } from "./Data";
import { projectsNav } from './Data';
import ProjectItems from "./ProjectItems";

const Projects = () => {
    const [item, setItem] =  useState({ name: "الكل" });
    const [projects, setProjects] = useState([]);
    const [active, setActive] = useState(0);

    useEffect(() => {
        if (item.name === "الكل") {
            // Filter out duplicate projects based on id
            const uniqueProjects = Array.from(new Set(projectsData.map(project => project.id)))
                .map(id => {
                    return projectsData.find(project => project.id === id)
                });
            setProjects(uniqueProjects);
        } else {
            const newProjects = projectsData.filter(project => project.category === item.name);
            setProjects(newProjects);
        }
    }, [item]);

    const handleClick = (e, index) => {
        setItem({ name: e.target.textContent });
        setActive(index);
    };

    return (
        <div>
            <div className="project__filters">
                {projectsNav.map((navItem, index) => (
                    <span 
                        onClick={(e) => handleClick(e, index)}
                        className={`${active === index ? 'active-project' : ''} project__item`}
                        key={index}
                    >
                        {navItem.name}
                    </span>
                ))}
            </div>
            <div className="project__container container grid">
                {projects.map(project => (
                    <ProjectItems item={project} key={project.id} />
                ))}
            </div>
        </div>
    );
}

export default Projects;
